/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const HomeElectronics = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 120 120">
    <path
      d="M114.01,27.79h-9.91V5.65c0-3.12-2.53-5.65-5.65-5.65s-5.65,2.53-5.65,5.65v22.14h-19.55V5.65c0-3.12-2.53-5.65-5.65-5.65s-5.65,2.53-5.65,5.65v22.14h-9.91c-3.12,0-5.65,2.53-5.65,5.65v18.92c0,18.27,13.45,33.41,30.96,36.16-.33,11.18-9.5,20.18-20.75,20.18s-20.78-9.32-20.78-20.78V17.73C35.8,7.95,27.84,0,18.07,0S.34,7.95.34,17.73v71.6c0,3.12,2.53,5.65,5.65,5.65s5.65-2.53,5.65-5.65V17.73c0-3.54,2.88-6.43,6.43-6.43s6.43,2.88,6.43,6.43v70.18c0,17.69,14.39,32.09,32.09,32.09s31.72-14.06,32.06-31.47c17.54-2.72,31.02-17.88,31.02-36.17v-18.92c0-3.12-2.53-5.65-5.65-5.65ZM108.36,52.36c0,13.97-11.37,25.34-25.34,25.34s-25.34-11.37-25.34-25.34v-13.26h50.68v13.26Z"
      fill="#21295c"
    />
  </BaseSvgIcon>
)

export default HomeElectronics
